

$(document).ready(function () {
    // Initialize search forms immediately on page load
    initializeSearchForms();

    // reCAPTCHA Accessibility Enhancement
    function enhanceRecaptchaAccessibility() {
        // Wait for reCAPTCHA to load, then enhance accessibility
        const checkForRecaptcha = () => {
            const recaptchaTextarea = document.getElementById('g-recaptcha-response');
            const recaptchaWidget = document.querySelector('.g-recaptcha');

            if (recaptchaTextarea) {
                // Add aria-label to the hidden textarea
                recaptchaTextarea.setAttribute('aria-label', 'reCAPTCHA verification response');
                recaptchaTextarea.setAttribute('aria-describedby', 'recaptcha-description');

                // Create a screen reader description
                if (!document.getElementById('recaptcha-description')) {
                    const description = document.createElement('div');
                    description.id = 'recaptcha-description';
                    description.className = 'sr-only';
                    description.textContent = 'Complete the reCAPTCHA verification to prove you are not a robot.';
                    recaptchaTextarea.parentNode.insertBefore(description, recaptchaTextarea);
                }
            }

            if (recaptchaWidget) {
                // Add role and aria-label to the widget container
                recaptchaWidget.setAttribute('role', 'group');
                recaptchaWidget.setAttribute('aria-label', 'reCAPTCHA verification widget');
            }
        };

        // Check immediately and also after a delay for async loading
        checkForRecaptcha();
        setTimeout(checkForRecaptcha, 1000);
        setTimeout(checkForRecaptcha, 3000);

        // Also check when the window loads (in case reCAPTCHA loads late)
        window.addEventListener('load', checkForRecaptcha);
    }

    // Initialize reCAPTCHA accessibility enhancement
    enhanceRecaptchaAccessibility();

    // ADA #148: Add <legend> to Umbraco Forms fieldsets that are missing one (WCAG 1.3.1 H71)
    function addUmbracoFormsLegends() {
        document.querySelectorAll('.umbraco-forms-field fieldset').forEach(function (fieldset) {
            if (fieldset.querySelector('legend')) return;
            var fieldDiv = fieldset.closest('.umbraco-forms-field');
            var labelEl = fieldDiv && fieldDiv.querySelector('label.umbraco-forms-label');
            var legend = document.createElement('legend');
            legend.className = 'visually-hidden';
            legend.textContent = labelEl ? labelEl.textContent.trim() : 'Field options';
            fieldset.insertBefore(legend, fieldset.firstChild);
        });
    }
    addUmbracoFormsLegends();

    // Fix duplicate id="__mcenew" from TinyMCE multi-instance pages (WCAG 4.1.1 F77)
    // TinyMCE reuses the same ID for its internal helper element across all instances.
    // Deduplicate by appending an index to every occurrence after the first.
    function fixDuplicateTinyMceIds() {
        const dedup = () => {
            const elements = document.querySelectorAll('[id="__mcenew"]');
            if (elements.length > 1) {
                elements.forEach((el, index) => {
                    if (index > 0) el.id = `__mcenew_${index}`;
                });
            }
        };
        setTimeout(dedup, 500);
        setTimeout(dedup, 1500);
        setTimeout(dedup, 3000);
        window.addEventListener('load', dedup);
    }
    fixDuplicateTinyMceIds();

    $('#desktop-search-icon .icon').on("click", function () {
        $("#desktop-search-icon").toggleClass("active");
        $(".searchOverlay").toggleClass("active");

        // Re-initialize search forms if not already done (backup)
        if (!$('.search_form form').length) {
            initializeSearchForms();
        }
    })

    function initializeSearchForms() {        // Desktop search form
        $('.search_form').html(`
            <form action="/search-results" method="GET" class="search-form">
                <div class="search-input-wrapper">
                    <input type="text" name="query" placeholder="Search..." class="search-input" aria-label="Conduct a search" autocomplete="off" required>
                    <button type="submit" class="search-button" aria-label="Submit search">
                        <img src="/media/1013/searchicon.png" alt="" class="search-icon">
                        <span class="sr-only">Submit</span>
                    </button>
                </div>
            </form>
        `);

        // Mobile search form
        $('.search_form2').html(`
            <form action="/search-results" method="GET" class="search-form">
                <div class="search-input-wrapper">
                    <input type="text" name="query" placeholder="Search..." class="search-input" aria-label="Conduct a search" autocomplete="off" required>
                    <button type="submit" class="search-button" aria-label="Submit search">
                        <img src="/media/1013/searchicon.png" alt="" class="search-icon">
                        <span class="sr-only">Submit</span>
                    </button>
                </div>
            </form>
        `);

        // Add focus behavior to enhance UX
        $('.search_form .search-input, .search_form2 .search-input').on('focus', function () {
            $(this).closest('.search-input-wrapper').addClass('focused');
        }).on('blur', function () {
            $(this).closest('.search-input-wrapper').removeClass('focused');
        });
    }

    $('.navbar-toggler').on("click", function () {
        $(".megaNav").toggleClass("active");
    })

    let items = document.querySelectorAll('.featuredContent .carousel-item')
    items.forEach((el) => {
        // number of slides per carousel-item
        const minPerSlide = 3
        let next = el.nextElementSibling
        for (var i = 1; i < minPerSlide; i++) {
            if (!next) {
                // wrap carousel by using first child
                next = items[0]
            }
            let cloneChild = next.cloneNode(true)
            el.appendChild(cloneChild.children[0])
            next = next.nextElementSibling
        }
    })


});


